import { combineReducers } from "redux";
import { alertReducer } from "./alert.reducer";
import { authenticationReducer } from "./authentication.reducer";
import { panelReducer } from './panel.reducer';
import { dashboardReducer } from "./dashboard.reducer";
import { networkDeviceReducer } from "./network-device.reducer";
import { modalReducer } from "./modal.reducer";
import { deviceTypeReducer } from "./device-type.reducer";
import { networkDeviceContentReducer } from "./network-device-content.reducer";
import { deviceGroupReducer } from "./device-group.reducer";
import { deviceGroupScheduleReducer } from "./device-group-schedule.reducer";
import { settingReducer } from "./setting.reducer";
import { userReducer } from "./user.reducer";
import { roleReducer } from "./role.reducer";
import { daliHelvarReducer } from "./dali-helvar.reducer";
import { exhibitionMapReducer } from "./exhibition-map.reducer";
import {daliEsSystemReducer} from "./dali-es-system.reducer";
import {logReducer} from "./log.reducer";
import {notificationReducer} from "./notification.reducer";
import {exhibitionScenarioReducer} from "./exhibition-scenario.reducer";
import {rfidReducer} from "./rfid.reducer";
import {pxmModbusReducer} from "./pxm-modbus.reducer";
import { reducer as toastrReducer } from 'react-redux-toastr'
import {networkResetDeviceReducer} from "./network-reset-device.reducer";

export default combineReducers({
    alertReducer,
    authenticationReducer,
    panelReducer,
    dashboardReducer,
    networkDeviceReducer,
    networkDeviceContentReducer,
    modalReducer,
    deviceTypeReducer,
    deviceGroupReducer,
    deviceGroupScheduleReducer,
    settingReducer,
    exhibitionMapReducer,
    userReducer,
    roleReducer,
    daliHelvarReducer,
    daliEsSystemReducer,
    logReducer,
    notificationReducer,
    exhibitionScenarioReducer,
    rfidReducer,
    pxmModbusReducer,
    networkResetDeviceReducer,
    toastr: toastrReducer,
});
